/**
 * usePersonaSessionRoles — reads per-session persona roles (currently
 * just Trailmaster) from CouncilContext.
 *
 * Returns trailmasterPersonaId as a stable string|null so caller equality
 * checks (`isTrailmaster = trailmasterPersonaId === personaId`) work
 * without coercion.
 */
import { useContext } from 'react';
import { CouncilContext } from '../contexts/CouncilContext';


export function usePersonaSessionRoles(_sessionId: string): {
  trailmasterPersonaId: string | null;
} {
  const ctx = useContext(CouncilContext);
  // core_persona_id is session_council_metadata.core_persona_id per spec §0.1.
  // CouncilContext stays null in Solo Trail sessions (no provider) —
  // returns null without throwing.
  const raw = ctx?.state?.metadata?.core_persona_id ?? null;
  const trailmasterPersonaId = raw ? String(raw) : null;
  return { trailmasterPersonaId };
}
